define('TescoMobile_Checkout/js/model/card-details-step-visibility',['Magento_Checkout/js/model/quote', 'Magento_Checkout/js/view/summary/abstract-total'], function (quote, abstractTotal) {
  'use strict';

  var _window$checkoutConfi, _tescoConfig$card_det;
  const tescoConfig = (_window$checkoutConfi = window.checkoutConfig) === null || _window$checkoutConfi === void 0 ? void 0 : _window$checkoutConfi.tescomobile,
    isFeatureEnabled = (tescoConfig === null || tescoConfig === void 0 || (_tescoConfig$card_det = tescoConfig.card_details) === null || _tescoConfig$card_det === void 0 ? void 0 : _tescoConfig$card_det.upgrade_no_payment_skip_step) || false;
  return {
    canShow: function () {
      return !(isFeatureEnabled && this.isUpgrade() && !this.hasPayment());
    },
    isUpgrade: function () {
      var _quote$getData;
      return ((_quote$getData = quote.getData('extension_attributes')) === null || _quote$getData === void 0 ? void 0 : _quote$getData.tm_quote_type) === 'UPGRADE';
    },
    hasPayment: function () {
      return abstractTotal().getTotals().base_grand_total > 0;
    }
  };
});

